import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Layout from "@/components/Page/Layout";
import Audio from "@/components/Page/Audio";
import { TFunction } from "next-i18next";
import { serverSidePage } from "@/utils/serverSide";
import { Website } from "@/types/website";
import { GetServerSideProps } from "next";

type Props = {
  website: Website;
};

export const PressPage = ({ website }: Props): React.ReactElement => (
  <Audio website={website} rounded={false} />
);

PressPage.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  const { website } = page.props;

  return (
    <Layout title={t("cloud.audio")} website={website}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
  req,
}) => ({
  props: {
    ...(await serverSidePage(query, req, false, "audio")),
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default PressPage;
